export const googleMapsMapping = {
	address: 'address',
	lat: 'lat',
	lng: 'lng',
	zoom: 'zoom',
	place_id: 'place_id',
	name: 'name',
	street_number: 'street_number',
	street_name: 'street_name',
	city: 'city',
	state: 'state',
	state_short: 'state_short',
	post_code: 'post_code',
	country: 'country',
	country_short: 'country_short',
};
